/**
 * Presentation-only GST split for Clarity tax invoices (PDF + hosted page).
 * Payable total is always `amountInclGst`. Breakdown is always shown —
 * when GST was not added on top, reverse-calculate from the inclusive total.
 */
export function presentInvoiceGstBreakdown(params: {
  amountInclGst: number;
  /** Proposal "Apply 9% GST on invoices" — true means agreed amount was ex-GST. */
  gstApplied: boolean;
}): {
  totalInclGst: number;
  subtotalExclGst: number;
  gstAmount: number;
  /** Amount shown in UNIT PRICE / AMOUNT columns. */
  lineUnitAmount: number;
  unitPriceHeader: "UNIT PRICE (EXCL. GST)" | "UNIT PRICE (INCL. GST)";
} {
  const round2 = (n: number) => Math.round(n * 100) / 100;
  const totalInclGst = round2(Number(params.amountInclGst) || 0);
  const subtotalExclGst = round2(totalInclGst / 1.09);
  const gstAmount = round2(totalInclGst - subtotalExclGst);
  if (params.gstApplied) {
    return {
      totalInclGst,
      subtotalExclGst,
      gstAmount,
      lineUnitAmount: subtotalExclGst,
      unitPriceHeader: "UNIT PRICE (EXCL. GST)",
    };
  }
  return {
    totalInclGst,
    subtotalExclGst,
    gstAmount,
    lineUnitAmount: totalInclGst,
    unitPriceHeader: "UNIT PRICE (INCL. GST)",
  };
}

export function formatInvoiceMoney(amount: number): string {
  const n = Number(amount);
  const v = Number.isFinite(n) ? n : 0;
  return new Intl.NumberFormat("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
}

export function formatInvoiceMoneyDollar(amount: number): string {
  return `$${formatInvoiceMoney(amount)}`;
}

export function formatInvoiceMoneySgd(amount: number): string {
  return `SGD $${formatInvoiceMoney(amount)}`;
}
